import {
  Button,
  useTheme
} from '@mui/material';

import { CustomIcon } from 'modules/components/layer00';
import { SavePersonModal } from 'modules/components/layer17';
import { UserProfileDetailCard } from 'modules/components/layer20';
import { ActivityHeaderSectionVerticalLayout } from 'modules/components/layer32';
import * as ds from './dataService';
import React, { useState } from 'react';



export type ProfileHeaderSectionProps = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: ProfileHeaderSectionProps) => {

  return (
    <ActivityHeaderSectionVerticalLayout.FC
      actionButtonsGroup={<ActionButtonsGroup />}
      title='Settings'
      subTitle='Edit your information'
    >
      <UserProfileDetailCard.FC />
    </ActivityHeaderSectionVerticalLayout.FC>
  );
};

type ActionButtonsGroupProps = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
const ActionButtonsGroup = (props: ActionButtonsGroupProps) => {
  const theme = useTheme();
  const [
    isVisible,
    setIsVisible
  ] = useState(false);
  const [fnSendTest] = ds.useSendTestNotificationToSelf();

  return (
    <>
      {isVisible && (
        <SavePersonModal.FC
          id=''
          isVisible={isVisible}
          handleClose={() => setIsVisible(() => false)}
        />
      )}
      <Button
        variant='outlined'
        color='info'
        onClick={async () => {
          await fnSendTest();
        }}

      >
        Send Test Notification
      </Button>
      <Button
        variant='contained'
        onClick={() => {
          setIsVisible(() => true);
        }}
        startIcon={(
          <CustomIcon.large.FC
            icon='EDIT'
            stroke={theme.palette.primary.contrastText}
          />
        )}
      >
        Edit
      </Button>
    </>
  );
};

